import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { erieConfig } from "./data";

export default function EriePage() {
  return <CityPageTemplate config={erieConfig} />;
}